import * as React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';

import { IconButton } from '@/components/IconButton/IconButton';
import { Popper } from '@/components/Popper/Popper';
import { CommentActionIcon } from '@/features/Comment/components/CommentActionIcon';

export const CommentButtonDisabled = () => {
  const CommentButtonRef = React.useRef<HTMLButtonElement>(null);
  const [showPopper, setShowPopper] = React.useState(false);
  return (
    <>
      <IconButton onClick={() => setShowPopper(true)} ref={CommentButtonRef}>
        <CommentActionIcon disabled />
      </IconButton>
      <Popper
        isVisible={showPopper}
        closePopper={() => {
          setShowPopper(false);
        }}
        placement='bottom'
        targetRef={CommentButtonRef}
        closeOnOutSideClick
      >
        <PopperContent>
          Cards originating from chats cannot be commented upon
        </PopperContent>
      </Popper>
    </>
  );
};

const PopperContent = styled.div`
  ${tw`bg-gray-900 text-white rounded body-sm shadow-app-panel`}
`;
